export const appendScript = (src, onLoadCallback, onReadyStateChangeCallback, options = {}) => {
  let script = document.createElement("script");
  script.src = src;
  script.async = options.async != undefined ? options.async : true;
  script.defer = options.defer != undefined ? options.defer : true;
  script.setAttribute("data-ot-ignore", "");
  if (typeof onLoadCallback == "function") {
    script.addEventListener("load", onLoadCallback);
  }
  if (typeof onReadyStateChangeCallback == "function") {
    script.addEventListener("readystatechange", onReadyStateChangeCallback);
  }
  document.head.appendChild(script);
};

export const loadAndAppendElement = ({
  elementType = "link",
  tagOptions: { onLoad, src, onReadyStateChange, ...otherTagOptions } = {},
  appendTo = "head",
  attributes = {},
}) => {
  const el = document.createElement(elementType);
  if (elementType === "script") {
    el.setAttribute("data-ot-ignore", "");
  }
  Object.entries(otherTagOptions).forEach(([key, value]) => (el[key] = value));
  Object.entries(attributes).forEach(([key, value]) => el.setAttribute(key, value));

  if (typeof onLoad === "function") {
    el.addEventListener("load", () => onLoad?.(el));
  }
  if (typeof onReadyStateChange === "function") {
    el.addEventListener("readystatechange", onReadyStateChange);
  }
  if (src) {
    el.src = src;
  }
  document[appendTo]?.appendChild(el);
};

export const loadCSSAndAppend = ({ href, rel = "stylesheet", appendTo = "head", ...options }) => {
  loadAndAppendElement({ elementType: "link", appendTo, tagOptions: { href, rel, ...options } });
};

export const asyncLoadAndAppend = ({
  elementType = "link",
  tagOptions: { onLoad, ...otherTagOptions } = {},
  appendTo = "head",
  attributes = {},
}) => new Promise((resolve) => {
  const onScriptLoad = (element) => {
    onLoad?.();
    resolve(element);
  }
  loadAndAppendElement({
    elementType,
    tagOptions: { onLoad: onScriptLoad, ...otherTagOptions },
    appendTo,
    attributes,
  })
});